import * as React from "react";
import {Fragment} from "react";
import {withRouter} from "react-router-dom";
import QuotationComponent from "../../../components/QuotationComponent";
import TransactionRequiredFieldsComponent from "../../../components/TransactionRequiredFieldsComponent";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import BeneficiaryService from "../../../services/Beneficiary/BeneficiaryService";
import SFXLoadingComponent from "../../../components/SFXLoadingComponent";
import {Card, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Beneficiary from "../../../domain/Beneficiary/Beneficiary";

const QUOTATION_REQUEST = "quotation request";
const BENEFICIARY_DETAILS = "beneficiary details";

class BeneficiaryCreation extends React.Component {

    constructor(props) {
        super(props);

        this.registerRef = null;

        this.state = {
            currentTab: QUOTATION_REQUEST,
            quotationRequest: null,
            quotationResponse: null,
            beneficiaryCreationRequest: null,
            requiredFieldsValid: false,
            loading: false,
            showErrorModal: false,
            beneficiaryCreationErrors: []
        };
    }

    componentDidMount() {
        this.props.setSelectedScreen("Beneficiaries");
    }

    retrieveQuotationResponse = (quotationRequest, quotationResponse) => {
        this.setState({
            quotationRequest: quotationRequest,
            quotationResponse: quotationResponse
        }, () => this.setState({
            currentTab: BENEFICIARY_DETAILS
        }))
    };

    requiredFieldsValid = isValid => {
        this.setState({
            requiredFieldsValid: isValid
        })
    };

    generateBeneficiaryCreationRequest() {

        let capturedValues = this.registerRef.getValues();

        let beneficiaryName = Beneficiary.generateBeneficiaryName(capturedValues["captured-fields"]);

        let beneficiaryCreationRequest = {};
        beneficiaryCreationRequest["id"] = 0;
        beneficiaryCreationRequest["registration-id"] = this.props.customer.registrationId;
        beneficiaryCreationRequest["beneficiary-name"] = beneficiaryName;
        beneficiaryCreationRequest["country-id"] = this.state.quotationRequest.countryId;
        beneficiaryCreationRequest["payout-method-id"] = this.state.quotationRequest.payoutMethodId;
        beneficiaryCreationRequest["payout-partner-id"] = this.state.quotationRequest.payoutPartnerId;
        beneficiaryCreationRequest["currency-id"] = this.state.quotationRequest.currencyId;
        beneficiaryCreationRequest["quotation-type"] = this.state.quotationRequest.quotationType;
        beneficiaryCreationRequest["amount"] = this.state.quotationRequest.amount;
        beneficiaryCreationRequest["quotation-reference"] = this.state.quotationResponse.quotationReference;
        beneficiaryCreationRequest["required-fields"] = capturedValues["captured-fields"];

        this.setState({
            loading: true,
            beneficiaryCreationRequest: beneficiaryCreationRequest
        }, () => this.createBeneficiary(beneficiaryCreationRequest))
    }

    createBeneficiary(beneficiaryCreationRequest) {

        BeneficiaryService.createBeneficiaryWithRequiredFields(beneficiaryCreationRequest).then(response => {
            if (response["error-code"]) {
                this.setState({
                    loading: false,
                    showErrorModal: true,
                    beneficiaryCreationErrors: response
                })
            } else {
                this.props.history.replace("/beneficiaries");
            }
        })
    }

    render() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>

            {this.props.isMobile ? this.renderContent("mobile") : this.renderContent("browser")}

        </Fragment>
    }

    renderContent(className) {

        return <Fragment>
            {this.state.currentTab === QUOTATION_REQUEST && this.renderQuotation(className)}
            {this.state.currentTab === BENEFICIARY_DETAILS && (className === 'mobile' ? this.renderRequiredFields(className) : this.renderBrowserRequiredFields(className))}

        </Fragment>

    }

    renderQuotation(className) {

        return <Fragment>

            <QuotationComponent
                className={className}
                returnQuotationResponse={this.retrieveQuotationResponse}
                setHeader={() => this.props.setHeader("New Beneficiary")}
            />

        </Fragment>
    }

    renderRequiredFields(className) {

        return <Fragment>

            {this.renderErrorModal(className)}

            <TransactionRequiredFieldsComponent
                className={className}
                registerRef={ref => this.registerRef = ref}
                requiredFields={this.state.quotationResponse.requiredFields}
                isValid={this.requiredFieldsValid}
                setHeader={() => this.props.setHeader("Beneficiary Details")}
                saveBeneficiary={false}
            />

            {this.renderCreateBeneficiaryButton(className)}
            {this.renderBackButton(className)}

        </Fragment>
    }

    renderBrowserRequiredFields(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderRequiredFields(className)}
        </Card>
    }

    renderCreateBeneficiaryButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_orange_oval_button"}
                onClick={() => this.generateBeneficiaryCreationRequest()}
                disabled={!this.state.requiredFieldsValid}
            >Complete
            </SFXButtonComponent>
        </div>
    }

    renderBackButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_grey_oval_button"}
                onClick={() => this.setState({currentTab: QUOTATION_REQUEST})}
            >Back
            </SFXButtonComponent>
        </div>
    }

    renderErrorModal(className) {

        return <Modal isOpen={this.state.showErrorModal}>

            <ModalHeader
                className={className + "_modal_header"}>{this.state.beneficiaryCreationErrors["message"]}</ModalHeader>
            <ModalBody>{this.state.beneficiaryCreationErrors["errors"]}</ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.setState({
                        showErrorModal: false,
                        currentTab: QUOTATION_REQUEST
                    })}
                >
                    Close
                </SFXButtonComponent>
            </ModalFooter>

        </Modal>

    }

}

export default withRouter(BeneficiaryCreation);